import React from "react";
import styles from "./EmptyCheckoutLeftContent.module.css";

export default function EmptyCheckoutLeftContent() {
    return <div className={styles.container} />;
}
